import { render, staticRenderFns } from "./HeaderMainMode.vue?vue&type=template&id=197a1368&"
import script from "./HeaderMainMode.vue?vue&type=script&lang=js&"
export * from "./HeaderMainMode.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMainMode.vue?vue&type=style&index=0&id=197a1368&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports